import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'semantic-ui-react'
import { formatCurrency, removeCommas, removeCommasAllowNeg } from 'globals/utils'

class InputNumber extends React.Component {
  
  componentDidMount(){
    if (!!this.props.min && this.props.value < this.props.min) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: this.props.min
        }
      }, {
          name: this.props.name,
          value: this.props.min
      })
    }
  } 
  componentDidUpdate(prevProps) {
    if ( !!this.props.min && prevProps.min !== this.props.min && this.props.value < this.props.min) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: this.props.min
        }
      }, {
          name: this.props.name,
          value: this.props.min
      })
    }
  }
  onChange = (e, h) => {
    const { allowNeg, max } = this.props
    let value = allowNeg ? removeCommasAllowNeg(e.target.value) : removeCommas(e.target.value)
    if (!!value && value !== '' && value !== '-') {
      if ((typeof max !== 'undefined' && max !== null) && value > max) {value = max}
    }
    if (!value && (value==='' || isNaN(value))){value = 0}  
    this.props.onChange({
      target: {
        name: e.target.name,
        value
      }
    }, {
      ...h,
      value
    })
  }

  onBlur = (e) => {
    if (!e.target.value)  {
      this.props.onChange({
        target: {
          name: e.target.name,
          value: 0
        }
      }, {
          name: e.target.name,
          value: 0
        })
    } else {
      const { allowNeg, min } = this.props
      let value = allowNeg ? removeCommasAllowNeg(e.target.value) : removeCommas(e.target.value)
      if (!!min && value < min) {value = min}
      this.props.onChange({
        target: {
          name: e.target.name,
          value: value
        }
      }, {
          name: e.target.name,
          value: value
      })
    }
  }

  selectValue = e => e.target.select()

  render() {
    const { icon, name, value, decimals, disabled, width, fluid, className, spinner, min, max } = this.props
    const _value =  (icon==='dollar')?formatCurrency(value, decimals, ''):value
    return (
      <Input style={width} fluid={fluid} className={className}
        onFocus={this.selectValue}
        disabled={disabled}
        icon={icon}
        iconPosition='left'
        value={ _value }
        name={ name }
        type={spinner?'number':'text'}
        min={min}
        max={max}
        onChange={ this.onChange }
        onBlur={ this.onBlur } 
        onKeyDown={this.props.onKeyDown}
        />
    );
  }
}

InputNumber.defaultProps = {
  disabled: false,
  allowNeg: false,  
  decimals: 0,
  icon: 'dollar',
  spinner: false,
  max: 100000000
}

// TODO: add value with CORRECT type
InputNumber.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  allowNeg: PropTypes.bool.isRequired
}

export default InputNumber;
